import { init, miniApp, themeParams, viewport } from "@tma.js/sdk";
import { useSignal } from "@tma.js/sdk-react";
import { useEffect } from "preact/hooks";

export function useTWA() {
  const isMounted = useSignal(miniApp.isMounted);

  useEffect(() => {
    try {
      init();
      themeParams.mount();
      miniApp.mount();
      viewport.expand();
      miniApp.ready();
      console.log("TWA инициализирован успешно");
    } catch (error) {
      console.error("Ошибка при инициализации TWA:", error);
    }
  }, []);

  return isMounted;
}
